import { Button } from '@blackjackfun/ui-components'
import { SizeProp } from '@fortawesome/fontawesome-svg-core'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface CloseButtonProps {
  onClick: () => void
  size?: SizeProp
}

const CloseButton = ({ onClick, size = 'lg' }: CloseButtonProps) => {
  return (
    <Button variant="inputButton" onClick={onClick}>
      <FontAwesomeIcon icon={faClose} size={size} className="py-6 px-4" />
    </Button>
  )
}

export default CloseButton
